import * as ImagesClient from '@shawfloors/images-client';

import Config from 'Config';
import * as Storage from 'Utils/Storage';

const IMAGES_TOKEN_KEY = 'IMAGES_TOKEN_KEY';

ImagesClient.init(Config.imagesBaseUrl);

export {
  Types,
  Urls,
  User,
  Util
} from '@shawfloors/images-client';

export function setImagesAuthorisation(auth: ImagesClient.Types.IOauthResult) {
  ImagesClient.setAuth(auth);
  Storage.setItem(IMAGES_TOKEN_KEY, auth, true);
}

export function clearImagesAuthorisation() {
  ImagesClient.setAuth({
    access_token: '',
    token_type: '',
    expires_in: 0,
  });
  Storage.removeItem(IMAGES_TOKEN_KEY);
}

export function getImagesAuthorisation(): ImagesClient.Types.IOauthResult {
  return Storage.getItem<ImagesClient.Types.IOauthResult>(IMAGES_TOKEN_KEY);
}
